import "./PinInput.scss"
import { FC, useEffect, useRef } from "react"
import { TextField, FormHelperText, Box } from "@mui/material"

export type PinType = {
  p1: string
  p2: string
  p3: string
  p4: string
}

type PinInputProps = {
  value: string
  onPinChange: (e: any) => void
  shouldFocus: boolean
  error?: boolean
  helperText?: string
}

const PinInput: FC<PinInputProps> = ({
  value,
  onPinChange,
  shouldFocus,
  error = false,
  helperText = "",
}) => {
  const inputRef = useRef<HTMLInputElement[]>([])

  useEffect(() => {
    if (shouldFocus) {
      inputRef.current[0]?.focus()
    }
  }, [shouldFocus])

  const handlePinChange = (index: number, newValue: string) => {
    if (newValue === "" || /^[0-9]$/.test(newValue)) {
      const newPin = value.split("")
      newPin[index] = newValue
      onPinChange(newPin.join(""))

      if (newValue && index < 3) {
        inputRef.current[index + 1]?.focus()
      }
    }
  }

  return (
    <Box className="pin-input-container">
      <div className="pin-inputs">
        {Array(4)
          .fill(null)
          .map((_, index) => (
            <TextField
              key={index}
              inputRef={(el) => (inputRef.current[index] = el)}
              value={value[index] || ""}
              onChange={(e) => handlePinChange(index, e.target.value)}
              inputProps={{ maxLength: 1, pattern: "[0-9]*" }}
              onKeyDown={(e) => {
                if (e.key === "Backspace" && !value[index] && index > 0) {
                  inputRef.current[index - 1]?.focus()
                }
              }}
              error={error}
            />
          ))}
      </div>
      {error && <FormHelperText error>{helperText}</FormHelperText>}
    </Box>
  )
}

export default PinInput
